<p-toast></p-toast>
<pg-digemid-products-select
  *ngIf="select.item.openDialog"
  (selectedRowsEvent)="onSelectedItem($event)"
></pg-digemid-products-select>

<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-sidebar [(visible)]="open" [fullScreen]="true" (onHide)="onClose()">
  <div class="card">
    <div class="grid p-fluid">
      <div class="col-12 md:col-6 col-offset-3">
        <div class="surface-card p-4 shadow-1 border-round">
          <div class="grid">
            <div
              class="font-medium text-2xl text-900 mb-3 col-12 md:col-11 label-required"
            >
              Medicamento Seleccionado
            </div>
            <div class="field col-12 md:col-1">
              <button
                pButton
                pRipple
                icon="pi pi-check-square"
                class="p-button-rounded p-button-info"
                (click)="select.item.openDialog = true"
                pTooltip="Seleccionar Medicamento"
                tooltipPosition="left"
              ></button>
            </div>
          </div>
          <ul class="list-none p-0 m-0">
            <li
              *ngFor="let item of itemDigemid"
              class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
            >
              <div class="text-500 w-2 md:w-5 font-medium">
                {{ item.label }}
              </div>
              <div
                class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
              >
                {{ item.value }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="grid col-12 md:col-6 col-offset-3">
        <div class="col-12">
          <form [formGroup]="fg">
            <div class="mt-3 mb-2">
              <p-fieldset
                legend="Datos"
                [toggleable]="true"
                class="mt-3 mb-2 md:mt-0"
              >
                <div class="p-fluid p-formgrid grid">
                  <div class="field col-12 md:col-6">
                    <label>Codigo de barras</label>
                    <input pInputText formControlName="barCode" type="text" />
                    <div
                      *ngIf="
                        fg.get('barCode').invalid &&
                        (fg.get('barCode').dirty || fg.get('barCode').touched)
                      "
                      class="p-invalid"
                    >
                      <div *ngIf="fg.get('barCode').errors?.required">
                        <small class="p-error">No puede quedar vacio.</small>
                      </div>
                      <div *ngIf="fg.get('barCode').errors?.minlength">
                        <small class="p-error"
                          >Debe tener una longitud minima de 5</small
                        >
                      </div>
                      <div *ngIf="fg.get('barCode').errors?.maxlength">
                        <small class="p-error"
                          >Debe tener una longitud maxima de 32.</small
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </p-fieldset>
            </div>
          </form>
        </div>
      </div>
      <div class="col-12 md:col-6 col-offset-3">
        <div class="">
          <p-fieldset legend="Formato de Venta" [toggleable]="true">
            <div class="p-fluid p-formgrid">
              <p-table
                [value]="hierarchyFormats"
                dataKey="id"
                editMode="row"
                responsiveLayout="scroll"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>Nombre</th>
                    <th>Sub Formato</th>
                    <th>Cantidad S.F</th>
                    <th>FV</th>
                    <th>FMV</th>
                    <th>FC</th>
                    <th style="width: 8rem"></th>
                  </tr>
                </ng-template>
                <ng-template
                  pTemplate="body"
                  let-format
                  let-editing="editing"
                  let-ri="rowIndex"
                >
                  <tr [pEditableRow]="format">
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <input
                            pInputText
                            type="text"
                            [disabled]="disabled"
                            [(ngModel)]="format.nombre"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{ format.nombre }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <input
                            pInputText
                            type="text"
                            [disabled]="format.FMV"
                            [(ngModel)]="format.subFormat"
                          />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{ format.subFormat }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-inputNumber
                            inputId="integeronly"
                            [disabled]="format.FMV"
                            [(ngModel)]="format.cantidad"
                            [min]="1"
                          >
                            >
                          </p-inputNumber>
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{ format.cantidad }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-toggleButton
                            [(ngModel)]="format.FV"
                            onIcon="pi pi-check"
                            offIcon="pi pi-times"
                          ></p-toggleButton>
                        </ng-template>
                        <ng-template pTemplate="output">
                          <i
                            [ngClass]="
                              format.FV === true ? 'pi pi-check' : 'pi pi-times'
                            "
                            style="font-size: 2rem"
                          ></i>
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-toggleButton
                            [(ngModel)]="format.FMV"
                            (click)="onChangeCheck(ri)"
                            onIcon="pi pi-check"
                            offIcon="pi pi-times"
                          ></p-toggleButton>
                        </ng-template>
                        <ng-template pTemplate="output">
                          <i
                            [ngClass]="
                              format.FMV === true
                                ? 'pi pi-check'
                                : 'pi pi-times'
                            "
                            style="font-size: 2rem"
                          ></i>
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-toggleButton
                            [(ngModel)]="format.FC"
                            onIcon="pi pi-check"
                            offIcon="pi pi-times"
                          ></p-toggleButton>
                        </ng-template>
                        <ng-template pTemplate="output">
                          <i
                            [ngClass]="
                              format.FC === true ? 'pi pi-check' : 'pi pi-times'
                            "
                            style="font-size: 2rem"
                          ></i>
                        </ng-template>
                      </p-cellEditor>
                    </td>

                    <td style="text-align: center">
                      <button
                        *ngIf="!editing"
                        pButton
                        pRipple
                        type="button"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        (click)="onHierarchyRowEdit(format)"
                        class="p-button-rounded p-button-text"
                      ></button>
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        type="button"
                        pSaveEditableRow
                        icon="pi pi-check"
                        (click)="onHierarchyRowEditSave(format)"
                        class="p-button-rounded p-button-text p-button-success mr-2"
                      ></button>
                      <button
                        *ngIf="editing"
                        pButton
                        pRipple
                        type="button"
                        pCancelEditableRow
                        icon="pi pi-times"
                        (click)="onHierarchyRowEditCancel(format, ri)"
                        class="p-button-rounded p-button-text p-button-danger"
                      ></button>
                    </td>
                    <td style="text-align: center">
                      <button
                        *ngIf="
                          ri == hierarchyFormatLength &&
                          !hierarchyFormats[hierarchyFormatLength].FMV
                        "
                        (click)="onHierarchyAddRow(ri)"
                        pButton
                        type="button"
                        class="p-button-success"
                        icon="pi pi-plus-circle"
                      ></button>
                    </td>
                    <td style="text-align: center">
                      <button
                        *ngIf="ri == hierarchyFormatLength && ri > 0"
                        (click)="onHierarchyDeleteRow()"
                        pButton
                        type="button"
                        class="p-button-danger"
                        icon="pi pi-minus-circle"
                      ></button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </p-fieldset>
        </div>
        <div class="p-fluid p-formgrid grid mt-3 mb-2">
          <div class="field col-12 md:col-8"></div>
          <div class="field col-12 md:col-2">
            <button
              pButton
              pRipple
              type="button"
              icon="pi pi-times"
              (click)="onClose()"
              class="p-button-text"
              label="No"
              pTooltip="Cancelar Cambios"
              tooltipPosition="top"
            ></button>
          </div>
          <div class="field col-12 md:col-2">
            <button
              type="button"
              (click)="onSubmit()"
              pButton
              [disabled]="!(hasPurchaseFormat && hasMinSaleFormat)"
              pRipple
              icon="pi pi-check"
              class="p-button-text"
              label="Si"
              tooltipPosition="top"
              pTooltip="Guardar Cambios"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-sidebar>
